import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3ece7e0d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "menu-box" }
const _hoisted_2 = { class: "close-menu" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "menu-title-box" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "Meny")
], -1))
const _hoisted_4 = { class: "menu-text-box" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Hem", -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<div class=\"menu-text-box\" data-v-3ece7e0d><a href=\"https://portal.zenitec.se/kalkyl/194abdf1-ff79-4647-a3ba-cd75aef077a5?fbclid=IwAR1_KJgG1PE2yD4Ka80bRwGnM3NYrxyQmwLLE2S9IE3xvycbxF2oEim92lw\" target=\"_blank\" data-v-3ece7e0d><h2 data-v-3ece7e0d>Räkna på ditt tak</h2></a></div><div class=\"menu-text-box\" data-v-3ece7e0d><a href=\"https://www.skatteverket.se/privat/fastigheterochbostad/gronteknik.4.676f4884175c97df4192860.html\" target=\"_blank\" data-v-3ece7e0d><h2 data-v-3ece7e0d>Skattereduktion</h2></a></div><div class=\"menu-text-box\" data-v-3ece7e0d><a href=\"https://swedbank.se/privat/privatlan-och-krediter/energilan/sollan.html\" target=\"_blank\" data-v-3ece7e0d><h2 data-v-3ece7e0d>Om Sollån</h2></a></div>", 3)
const _hoisted_10 = { class: "menu-text-box" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Om oss", -1))
const _hoisted_12 = [
  _hoisted_11
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
      }, [
        _createVNode(_component_Icon, {
          class: "close-menu-btn",
          icon: "ph:x-duotone"
        })
      ])
    ]),
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("a", {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.scrollToTop(), _ctx.close()))
      }, _hoisted_6)
    ]),
    _hoisted_7,
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("a", {
        href: "#about",
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
      }, _hoisted_12)
    ])
  ]))
}